import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

export type AppViewState = {
    isLoading: boolean
    result: Http.Connection.Response.Apps.View['result'] | undefined
};

type Connection = AppsViewConnection;

export const useAppView = () => {
    const [state, setState] = useState<AppViewState>({
        isLoading: false,
        result: undefined,
    });
    const dispatch = useDispatch();
    const appsViewConnection = useAppSelector(state => state.appsViewConnection);

    const effect = (connection: Connection) => {
        const { meta, payload: { result } } = connection;
        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState(state => ({
                    ...state,
                    isLoading: meta.fetch,
                    result: result,
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState(state => ({
                    ...state,
                    isLoading: false,
                    result: undefined,
                }));
                return;
            }
            default: {
                break;
            }
        }
    }

    useEffect(() => {
        effect(appsViewConnection)
    }, [appsViewConnection]);// eslint-disable-line react-hooks/exhaustive-deps

    const request = useCallback((uuid: string) => {
        setState(state => ({
            ...state,
            isLoading: true,
        }));

        const viewAction = Actions.http.connection.apps.view;
        dispatch(viewAction(uuid));
    }, [dispatch]);

    const resetState = useCallback(() => {
        setState({
            isLoading: false,
            result: undefined,
        });
    }, []);

    return [state, request, resetState] as const;
};
